import { Outlet, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

function PrivateAdminRoutes() {
  const userData = localStorage.getItem("userData");
  console.log(userData)

  if (!userData) {
    return <Navigate to="/login" replace />;
  }

  try {
    const parsedData = JSON.parse(userData);
    console.log(parsedData)

    const decodedToken = jwtDecode(parsedData.token); // ✅ correct path

    return <Outlet />;
  } catch (error) {
    console.error("Token decoding error:", error);
    return <Navigate to="/login" replace />;
  }
}

export default PrivateAdminRoutes;
